// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".burger-button[data-v-f575f94e]{background-color:transparent;border:none;cursor:pointer;font-style:normal;font-weight:400;font-size:16px;line-height:22px;display:flex;flex-direction:row;align-items:center;justify-content:center}.burger-button .icon[data-v-f575f94e]{position:relative}.burger-button .icon .red-dot[data-v-f575f94e]{display:inline-block;position:absolute;width:10px;height:10px;border-radius:50%;background-color:#da3636;border:1px solid #fff;right:10px;top:-5px}", ""]);
// Exports
module.exports = exports;
